const INITIAL_STATE = {
    data: null
};

const ProvinciasReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'provincias':
            return { ...state, data: action.payload.provincias };
        default:
            return state;
    }
};

export default ProvinciasReducer;
